<!--
 * @Author: Viviyaaaa 870951135@qq.com
 * @Date: 2024-04-04 11:21:03
 * @LastEditors: Viviyaaaa 870951135@qq.com
 * @LastEditTime: 2024-04-10 19:47:24
 * @FilePath: \krpano-vue - 副本\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app" v-cloak >
    <KrpanoView/>
  </div>
</template>

<script>
import KrpanoView from './components/KrpanoView.vue';
export default {
  name: "App",
  components: {
    KrpanoView
  },


 
};
</script>

<style lang="scss">
  body,
  html {
      height: 100%;
  }，

  #app {
    height: 100%;
  }


</style>
